import React, { FC, useEffect } from 'react';
import { setAppTheme } from 'src/components/pages/settings/tenant/theme/setAppTheme';
import { useTenantConfig } from 'src/utils/hooks/useTenantConfig';

const isTestEnv = process.env.NODE_ENV === 'test';

export const DesignTokensProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const tenantConfig = useTenantConfig();

  useEffect(() => {
    if (tenantConfig && !isTestEnv) {
      setAppTheme(tenantConfig.features?.appearance?.config?.theme);
    }
  }, [tenantConfig]);

  return <>{children}</>;
};
